import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Batiment} from "../Models/Batiment";
import {AppComponent} from "../app.component";
import {AnalyticsService} from "../services/analytics.service";
import _, {cloneDeep} from 'lodash';
import {loadStripe} from '@stripe/stripe-js';
import {environment} from 'src/environments/environment';
import {specialCompaniesParcours} from "../const/utils";
import {ROUTES_PATHS} from "../const/routes";
import {SiteKeyEnum} from "../enums/site-key.enum";
import {getEstimationFromId} from "../helpers/estimation.helper";
import {finalize, switchMap} from "rxjs/operators";

@Component({
	selector: 'app-transaction',
	templateUrl: './transaction.component.html',
	styleUrls: ['./transaction.component.less'],
	encapsulation: ViewEncapsulation.None
})
export class TransactionComponent implements OnInit {
	textes: any = "";
	globalTxt: any = "";
	modalsTxt: any = "";
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	simUuid: string = JSON.parse(localStorage.getItem("simUuid")!);
	success: boolean = false;
	result: any = null;
	token = JSON.parse(localStorage.getItem("token")!);
	specialCompanies = specialCompaniesParcours;
	loading: boolean = false;

	constructor(
		public app: AppComponent,
		public analyticsService: AnalyticsService
	) {
	}

	/** Alternative button label for the special companies, and for KTV_EXTERNAL after a successful payment. */
	get useBtnLabelAutre(): boolean {
		const refId = this.app.sharedToolsService.returnObjectSwitchRefId();
		if (refId === SiteKeyEnum.KTVEXTERNAL) return this.success;
		return this.specialCompanies.indexOf(refId) != -1;
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts (error messages)
			this.app.dataInitService.getModalTextsOnce(modalsTxt => this.modalsTxt = modalsTxt);

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					let params: any = this.app.sharedToolsService.getURLParameter();

					if (params && !_.isEmpty(params)) {
						this.app.apiToolsService.changeKtvTransationStatus(params.traUuid, params.statut)
							.subscribe((res: any) => {
								console.log("changeKtvTransationStatus ==> ", res);

								if (params.statut != "260ca9dd8a4577fc00b7bd5810298076") {
									this.success = false;
									this.result = this.textes.fail;
									return;
								}

								this.token.simuTotal = res.simuTotal;
								this.token.simuUsed = res.simuUsed;
								this.token.outOfSimu = res.outOfSimu;
								localStorage.setItem("token", JSON.stringify(this.token));

								this.success = true;
								this.result = this.textes.success;
							});
					}
				});
		});
	}

	goToNextStep(success: boolean) {
		let eventLabel: string = success ? 'value : Paiement réussi' : 'value : Paiement échoué';
		// Tracking Analytics : Module de paiement
		this.analyticsService.trackEvent('user_interaction', 'click_module_paiement', eventLabel);

		if (success) {
			if (this.app.sharedToolsService.returnObjectSwitchRefId() === SiteKeyEnum.KTVEXTERNAL) {
				this.endKtvExternalParcours();
				return;
			}

			if (specialCompaniesParcours.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) != -1) {
				this.app.apiToolsService.generationSurfaceEtMobilierSimulation(parseInt(this.batiment.simulationId!)).subscribe(reponse => {
					console.log("res generationSurfaceEtMobilierSimulation", reponse);
					this.app.router.navigate(['/' + ROUTES_PATHS.ESTIMATION_RAPIDE]);
				});
				return;
			}

			this.app.router.navigate(['/' + ROUTES_PATHS.WELCOME]);
			return;
		}

		if (specialCompaniesParcours.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) != -1) {
			// Get the guid in local storage
			let guid = cloneDeep(localStorage.getItem("guid"));
			let guid2 = guid?.replace(/"/g, '');
			// Delete the local storage
			localStorage.clear();
			// Add params in router.navigate
			location.href = '/?guid=' + guid2;
			return;
		}

		this.app.router.navigate(['/' + ROUTES_PATHS.PRODUITS]);
	}

	/**
	 * KTV_EXTERNAL (KTV-55), after a successful payment: one estimation is used (PATCH /users/current/add-simulation-used),
	 * the simulation is reloaded, then redirection to the quick estimation page.
	 */
	private endKtvExternalParcours() {
		if (this.loading) return;
		this.loading = true;

		this.app.apiToolsService.trialSimulationUsed(this.simUuid?.replace(/"/g, '')).pipe(
			switchMap(() => getEstimationFromId(parseInt(this.batiment?.simulationId!), this.app.apiToolsService)),
			finalize(() => this.loading = false)
		).subscribe({
			next: () => this.app.router.navigate(['/' + ROUTES_PATHS.ESTIMATION_RAPIDE]),
			error: (err: any) => {
				console.error("endKtvExternalParcours error ==> ", err);
				this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalErrorApi, "alert", "", () => {
				}, () => {
				});
			}
		});
	}
}
